import './style/index.js';

import _Watermark from './Watermark';

export * from './type';
export type { WatermarkProps } from './Watermark';

export const Watermark = _Watermark;
export default Watermark;
